import React from "react";
import { Helmet } from "react-helmet-async";
import { useHelmetDexteel } from "./HelmetDexteelContext";

export const HelmetDexteel = ({
	title,
	...props
}: {
	title: React.ReactNode;
}) => {
	const { navbarTitle } = useHelmetDexteel();

	return (
		<Helmet defer={false} {...props}>
			<title>
				{title} - {navbarTitle}
			</title>
		</Helmet>
	);
};
